import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'objectLength'})

export class ObjectKeysPipe implements PipeTransform {
  transform(value: any, args: string[]): any {
    return Object.keys(value).length;
  }
}
